




import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { EventModel } from "@/models/event";

@Component({})
export class Visit extends Vue {
  @Prop({ required: true })
  event!: EventModel;

  @Prop()
  disabled!: boolean;
}
export default Visit;
